import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Collapse } from 'react-collapse';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';
import Field from 'containers/Field';
import Checkmark from './components/Checkmark';
import Subtext from './components/Subtext';
import Content from './components/Content';
import DetailHandle from './components/DetailHandle';
import Label from './components/Label';

import commonStyles from './styles';

const styles = (theme) => {
  const common = {
    ...commonStyles(theme),
  };
  return {
    ...common,
    apy: {
      paddingTop: 15,
    },
    rate: {
      paddingTop: 15,
    },
  };
};

export const TermDepositBare = ({
  classes,
  fieldAmount,
  fieldChosen,
  fieldTerm,
  fieldTermValue,
  isInAllBundle,
  labelAPY,
  labelRate,
  name,
  offerLabelText,
  rates,
  showOffersDetails,
  subText,
  termApyMap,
  termRateMap,
}) => {
  const [collapsed, setCollapse] = useState(!showOffersDetails);
  const hasTermRateMap = termRateMap && Object.keys(termRateMap).length > 0;
  const hasTermApyMap = termApyMap && Object.keys(termApyMap).length > 0;

  return (
    <>
      {!isInAllBundle ? <Checkmark name={name} /> : <Label label={offerLabelText} />}
      <DetailHandle setCollapse={setCollapse} collapsed={collapsed} />
      <Collapse isOpened={!collapsed}>
        <div className="content">
          <Content fieldChosen={fieldChosen} collapsed={collapsed}>
            <Subtext>{subText}</Subtext>
            {rates && <Field fieldName={rates} groupName={name} />}
            {(hasTermApyMap || hasTermRateMap) && (
              <div className={classnames('stats', classes.stats)}>
                {hasTermRateMap && (
                  <div className={classnames('rate', classes.rate)}>
                    <RawHtml type="span" className={classes.label}>
                      {labelRate}
                    </RawHtml>{' '}
                    <span className={classnames('val', classes.value)}>
                      {`${termRateMap[fieldTermValue]}%`}
                    </span>
                  </div>
                )}
                {hasTermApyMap && (
                  <div className={classnames('apy', classes.apy)}>
                    <RawHtml type="span" className={classes.label}>
                      {labelAPY}
                    </RawHtml>{' '}
                    <span className={classnames('val', classes.value)}>
                      {`${termApyMap[fieldTermValue]}%`}
                    </span>
                  </div>
                )}

                {hasTermRateMap && (
                  <div className={classnames('region-field-term', classes.amount)}>
                    <Field fieldName={fieldTerm} groupName={name} />
                  </div>
                )}
                {(hasTermApyMap || hasTermRateMap) && (
                  <div className={classnames('region-field-amount', classes.amount)}>
                    <Field fieldName={fieldAmount} groupName={name} />
                  </div>
                )}
              </div>
            )}
          </Content>
        </div>
      </Collapse>
    </>
  );
};

TermDepositBare.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  fieldAmount: PropTypes.string,
  fieldChosen: PropTypes.string,
  fieldTerm: PropTypes.string,
  fieldTermValue: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.string.isRequired]),
  isInAllBundle: PropTypes.bool,
  labelAPY: PropTypes.string,
  labelRate: PropTypes.string,
  name: PropTypes.string.isRequired,
  offerLabelText: PropTypes.string,
  rates: PropTypes.string,
  showOffersDetails: PropTypes.bool.isRequired,
  subText: PropTypes.string,
  termApyMap: PropTypes.shape({}),
  termRateMap: PropTypes.shape({}),
};

TermDepositBare.defaultProps = {
  fieldAmount: '',
  fieldChosen: '',
  fieldTerm: '',
  fieldTermValue: null,
  isInAllBundle: false,
  labelAPY: '',
  labelRate: '',
  offerLabelText: '',
  rates: '',
  subText: '',
  termApyMap: {},
  termRateMap: {},
};

const TermDepositBase = withStyles(styles)(TermDepositBare);

const mapDispatchToProps = ({ configs, data, offers }, { name }) => {
  const offer = offers[name];

  return {
    fieldAmount: offer.fieldAmount,
    fieldChosen: offer.fieldChosen,
    fieldTerm: offer.fieldTerm,
    fieldTermValue: data[offer.fieldTerm],
    labelAPY: offer.labelAPY,
    labelRate: offer.labelRate,
    offerLabelText: offer.label,
    rates: offer.rates,
    showOffersDetails: configs.showOffersDetails,
    subText: offer.subText,
    termApyMap: offer.termApyMap,
    termRateMap: offer.termRateMap,
  };
};

export default connect(mapDispatchToProps)(TermDepositBase);
